import {
  SecureIcon,
  AutoPitIcon,
  BenchIcon,
  CafeIcon,
  CanalIcon,
  ChurchIcon,
  CommerceIcon,
  ConciergeIcon,
  ElectricityIcon,
  FireIcon,
  FuelIcon,
  GasIcon,
  GymIcon,
  HospitalIcon,
  InstituteIcon,
  KindergartenIcon,
  MarketIcon,
  MoviesIcon,
  MuseumIcon,
  OfficeIcon,
  ParkingIcon,
  ResortIcon,
  StudioIcon,
  PerimetrIcon,
  PetsIcon,
  PlaygroundIcon,
  PoliceIcon,
  PoolIcon,
  PassIcon,
  RadiatorIcon,
  RoadIcon,
  SecureCamIcon,
  SignalIcon,
  SportsIcon,
  SquareIcon,
  StadiumIcon,
  TheaterIcon,
  WashingIcon,
  WaterSystemIcon,
  ZooIcon,
  SpaIcon,
} from '../components/common/icons';
import { VillageInfrastructureTypes } from '../types';

export const iconInfrastructure = {
  canalization: CanalIcon, // Канализация
  electricity: ElectricityIcon, // Электричество
  gas: GasIcon, // Газ
  heating: RadiatorIcon, // Отопление
  road: RoadIcon, // Дороги
  waterSupply: WaterSystemIcon, // Водоснабжение
  [VillageInfrastructureTypes.Playground]: PlaygroundIcon, // Детские площадки
  [VillageInfrastructureTypes.Rest]: ResortIcon, // Места для отдыха
  [VillageInfrastructureTypes.Resort]: BenchIcon, // Курортная зона
  [VillageInfrastructureTypes.Cinema]: MoviesIcon, // Кино
  [VillageInfrastructureTypes.Theater]: TheaterIcon, // Театр
  [VillageInfrastructureTypes.Lake]: PoolIcon, // Озеро
  [VillageInfrastructureTypes.River]: PoolIcon, // Река
  [VillageInfrastructureTypes.Gulf]: PoolIcon, // Залив
  [VillageInfrastructureTypes.Pond]: PoolIcon, // Пруд
  [VillageInfrastructureTypes.Park]: BenchIcon, // Парковая зона
  [VillageInfrastructureTypes.Reserve]: BenchIcon, // Заповедник
  [VillageInfrastructureTypes.Forest]: BenchIcon, // Лесная зона
  [VillageInfrastructureTypes.KinderGarten]: KindergartenIcon, // Детский сад
  [VillageInfrastructureTypes.School]: InstituteIcon, // Школа
  [VillageInfrastructureTypes.Institute]: InstituteIcon, // Институт
  [VillageInfrastructureTypes.Studio]: StudioIcon, // Студии
  [VillageInfrastructureTypes.Polyclinic]: HospitalIcon, // Поликлиника
  [VillageInfrastructureTypes.Hospital]: HospitalIcon, // Больница
  [VillageInfrastructureTypes.Clinic]: HospitalIcon, // Медпункт
  [VillageInfrastructureTypes.Pharmacy]: HospitalIcon, // Аптеки
  [VillageInfrastructureTypes.VeterinaryClinic]: HospitalIcon, // Ветеринарная клиника
  [VillageInfrastructureTypes.DogsWalking]: PetsIcon, // Площадки для выгула собак
  [VillageInfrastructureTypes.Zoo]: ZooIcon, // Зоопарк
  [VillageInfrastructureTypes.SportsGround]: SportsIcon, // Спортивные площадки
  [VillageInfrastructureTypes.Fitness]: GymIcon, // Фитнес-центр
  [VillageInfrastructureTypes.Spa]: SpaIcon, // SPA-центр
  [VillageInfrastructureTypes.Pool]: PoolIcon, // Бассейн
  [VillageInfrastructureTypes.Stadium]: StadiumIcon, // Стадион
  [VillageInfrastructureTypes.Police]: PoliceIcon, // Полиция
  [VillageInfrastructureTypes.Fire]: FireIcon, // Пожарная служба
  [VillageInfrastructureTypes.Perimeter]: PerimetrIcon, // Огороженный периметр
  [VillageInfrastructureTypes.Video]: SecureCamIcon, // Видеонаблюдение
  [VillageInfrastructureTypes.Access]: PassIcon, // Пропускная система
  [VillageInfrastructureTypes.Security]: SecureIcon, // Круглосуточная охрана
  [VillageInfrastructureTypes.Concierge]: ConciergeIcon, // Консьерж
  [VillageInfrastructureTypes.GuardedParking]: ParkingIcon, // Охраняемая парковка
  [VillageInfrastructureTypes.Signaling]: SignalIcon, // Сигнализация
  [VillageInfrastructureTypes.Supermarket]: MarketIcon, // Супермаркет
  [VillageInfrastructureTypes.Shop]: MarketIcon, // Магазин
  [VillageInfrastructureTypes.Restaurant]: CafeIcon, // Рестораны
  [VillageInfrastructureTypes.ShoppingCenter]: MarketIcon, // Торговый центр
  [VillageInfrastructureTypes.Church]: ChurchIcon, // Церковь
  [VillageInfrastructureTypes.Museum]: MuseumIcon, // Музеи
  [VillageInfrastructureTypes.Square]: SquareIcon, // Площади
  [VillageInfrastructureTypes.CarService]: AutoPitIcon, // Автосервис
  [VillageInfrastructureTypes.GasStation]: FuelIcon, // АЗС
  [VillageInfrastructureTypes.Commercial]: CommerceIcon, // Коммерческие объекты
  [VillageInfrastructureTypes.Office]: OfficeIcon, // Офисы
  [VillageInfrastructureTypes.SelfService]: WashingIcon, // Бытовые услуги
  [VillageInfrastructureTypes.Parking]: ParkingIcon, // Парковки
};
